import React from 'react';
import { find, findIndex, pathOr, propEq } from 'ramda';
import { scrollSpy } from 'react-scroll';
import { useIntl } from 'gatsby-plugin-intl';

import { REPORT_CONTENT_ID } from '../../utils/constants';
import { renderPage } from '../../utils/rendering';
import { Container, ContentWrapper } from '../../components/layout';
import { TableOfContents, SECTIONS_ORDER } from '../../components/tableOfContents';
import {
  Footer,
  FooterContent,
  FooterLink,
  FooterSectionName,
  FooterSectionNumber,
  FooterSectionWrapper,
  FooterTitle,
} from './reportPage.styles';
import { PARTNERS } from '../homepage/homepage.constants';
import SEO from '../../components/seo';
import { Footer as FooterComponent } from '../../components/footer';
import { Language } from '../../components/changeLocale';

const renderFooterSectionNumber = (index) => {
  const intl = useIntl();
  if (index < 5) {
    return (
      <FooterSectionNumber>
        {intl.formatMessage({ id: 'Chapter' })} {index}
      </FooterSectionNumber>
    )
  } else if (index === 5) {
    return (
      <FooterSectionNumber>
        {intl.formatMessage({ id: 'Appendix A' })}
      </FooterSectionNumber>
    )
  } else if (index === 6) {
    return (
      <FooterSectionNumber>
        {intl.formatMessage({ id: 'Appendix B' })}
      </FooterSectionNumber>
    )
  } else if (index === 7) {
    return (
      <FooterSectionNumber>
        {intl.formatMessage({ id: 'Appendix C' })}
      </FooterSectionNumber>
    )
  }
}

const renderFooterLink = (url) => {
  const intl = useIntl();
  const sectionID = url.split("/").splice(url.split("/").length - 1, 1)[0]
  if (sectionID === 'what-is-pefa') {
    return (
      <FooterLink to={url}>{intl.formatMessage({ id: 'Read Appendix' })}</FooterLink>
    )
  } else if (sectionID === 'methodology' || sectionID === 'gender-responsiveness'){
    return (
      <FooterLink to={url}>{intl.formatMessage({ id: 'Next Appendix' })}</FooterLink>
    )
  } else return (
    <FooterLink to={url}>{intl.formatMessage({ id: 'Next Chapter' })}</FooterLink>
  )
}

export const renderFooter = (currentSlug, tableOfContents) => {
  const currentIndex = findIndex(propEq('id', currentSlug))(SECTIONS_ORDER);
  const { id, index, category } = SECTIONS_ORDER[currentIndex + 1] || SECTIONS_ORDER[0];
  const { name } = find(propEq('slug', id))(tableOfContents) || {};
  const url = `/report/${id}`;
  const intl = useIntl();

  return (
    <Footer category={category}>
      <FooterSectionWrapper>
        <FooterSectionName>{intl.formatMessage({ id: category })}</FooterSectionName>
        {renderFooterSectionNumber(index)}
      </FooterSectionWrapper>
      <FooterContent>
        <FooterTitle>{intl.formatMessage({ id: name })}</FooterTitle>
        {renderFooterLink(url)}
      </FooterContent>
    </Footer>
  );
};

export const ReportPageComponent = ({
  pageContext: { pages, tableOfContents, slug, homepageContent: { sections = [] } = {}, seo },
  location: { pathname, hash },
}) => {
  const data = {};
  const partnersListLogos = find(propEq('id', PARTNERS))(sections);
  const image = {
    path: pathOr('', ['image', 'image'], seo),
    height: '600px',
    width: '600px',
  };

  return (
    <Container>
      <SEO {...seo} image={image} />
      <Language />
      <TableOfContents
        logoList={partnersListLogos}
        tableOfContents={tableOfContents}
        activeMenu={pathname}
        hash={hash}
      />
      <ContentWrapper id={REPORT_CONTENT_ID}>
        {pages.map(renderPage(data))}
        {renderFooter(slug, tableOfContents)}
        <FooterComponent />
      </ContentWrapper>
    </Container>
  );
};

export class ReportPage extends React.PureComponent {
  componentDidMount() {
    scrollSpy.update();
  }

  render() {
    return <ReportPageComponent {...this.props} />;
  }
}
